const header = {
  "header.menu_01": "首頁",
  "header.menu_02": "了解安視優®睛漾水凝®",
  "header.menu_03": "線上試戴",
  "header.menu_04": "門市查詢",
  "header.list_menu_01": "全系列",
  "header.list_menu_02": "經典/璀璨系列",
  "header.list_menu_03": "花眸/甜漾系列",
  "header.store_locator": "門市查詢",
  "header.store_01": "Lazada",
  "header.store_02": "Qoo10",
  "header.store_03": "Shopee",
}

export default header

